<template>
  <div>
    <h1>Add events</h1>
    <v-text-field
      label="Search for file reference"
      v-model="fileidTemp"
      @input="searchFile"
      outline
    />
    <Matter
      :fileid="fileid"
      @loaded="updateLoaded($event)"
      @loadedFile="updateFile($event)"
      @loadedClients="updateClients($event)"
    />
    <v-alert :value="fileid && !fileLoaded" type="warning"
      >No record found</v-alert
    >
    <v-alert :value="!fileid && !fileLoaded" type="info"
      >No record selected</v-alert
    >
    <v-card v-if="fileLoaded">
      <v-card-text>
        <v-form ref="formEvent">
          <v-select
            label="Select event type"
            v-model="event.eventtypeid"
            :items="eventTypes"
            item-value="id"
            item-text="name"
            outline
          />
          <DateDropdown label="Date" v-model="event.customdate" />
          <v-btn @click="saveEvent"> <v-icon>save</v-icon>Save </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="headers"
      :items="addEvents"
      hide-actions
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>{{ props.item.event.customdate | formatDate }}</td>
          <td>
            <FileZ :file="props.item.file" />
          </td>
          <td>
            <EntityZ
              :entity="client"
              v-for="client in props.item.clients"
              :key="client.id"
            />
          </td>
          <td>{{ props.item.eventType.name }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import EntityZ from "@/components/link/EntityZ";
import FileZ from "@/components/link/FileZ";
import Matter from "@/components/file/matter/Matter.vue";
import DateDropdown from "@/components/date/DateDropdown";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "AddEvents",
  metaInfo() {
    return {
      title: "Add events",
      titleTemplate: "%s - File - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: { EntityZ, FileZ, DateDropdown, Matter },
  computed: {
    computedEventType() {
      if (!this.eventTypes) {
        return undefined;
      }
      if (!this.event) {
        return undefined;
      }
      return this.eventTypes.find((t) => t.id == this.event.eventtypeid);
    }
  },
  data() {
    return {
      fileidTemp: "",
      fileid: null,
      fileLoaded: false,
      file: null,
      clients: null,
      eventTypes: [],
      event: {
        eventtypeid: null,
        customdate: new Date().toISOString().substr(0, 10)
      },
      addEvents: [],
      headers: [
        {
          text: "Date",
          sortable: false
        },
        {
          text: "File",
          sortable: false
        },
        {
          text: "Clients",
          sortable: false
        },
        {
          text: "Event type",
          sortable: false
        }
      ]
    };
  },
  methods: {
    updateLoaded(value) {
      this.fileLoaded = value;
    },
    updateFile(file) {
      this.file = file;
    },
    updateClients(clients) {
      this.clients = clients;
    },
    searchFile() {
      clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        this.fileid = this.fileidTemp;
      }, 750);
    },
    async fetchEventTypes() {
      const response = await nbmlaw.get(`/cors/admin/file/eventTypes`);
      // console.log(response.data);
      this.eventTypes = response.data;
    },
    async saveEvent() {
      await nbmlaw.post(
        `/cors/admin/file/files/${this.file.id}/events`,
        this.event
      );
      // console.log(response.data);
      const file = JSON.parse(JSON.stringify(this.file));
      const clients = JSON.parse(JSON.stringify(this.clients));
      const event = JSON.parse(JSON.stringify(this.event));
      const eventType = this.computedEventType;
      const addEvent = { file, clients, event, eventType };
      this.addEvents.push(addEvent);
    }
  },
  created() {
    this.fetchEventTypes();
  }
};
</script>

<style>
</style>
